import React, {Component} from 'react';
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import { Table } from 'semantic-ui-react'
import {getChartColors, minutesToHuman} from '../../Helpers'
import {Pie} from 'react-chartjs-2';
import PropTypes from 'prop-types';
class ReportCommesseGaraLavoratori extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items:[],
            pieData: {},
            total: 0,
            durataTotale: 0,
            durataPesataTotale: 0,
            numAttivitaTotale: 0,
            _loading: false,
            error: null,
        };
        this.loadData = this.loadData.bind(this)
    }

    componentWillUnmount() {
    }

    componentDidMount() {
        this.loadData(this.props.commessa.idCommessa);
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.commessa !== this.props.commessa)
        {
            this.loadData(nextProps.commessa.idCommessa);
        }
    }

    loadData(idCommessa) {

        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.loadReportCommesseGaraLavoratori(idCommessa).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{

                    this.setState({
                        items: data.items,
                        pieData: this.createPieData(data.items),
                        total: data.total,
                        durataTotale: data.durataTotale,
                        durataPesataTotale: data.durataPesataTotale,
                        numAttivitaTotale: data.numAttivitaTotale,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    createPieData(items)
    {
        let labels = [];
        let datas = [];
        for(let i=0; i<items.length; i++){

            labels.push(items[i].idUtente.username);
            datas.push(items[i].durataPesata);

        }

        const data = {
            labels: labels,
            datasets: [{
                data: datas,
                backgroundColor: getChartColors(),
                hoverBackgroundColor: getChartColors(),
            }]
        };
        return data;
    }

    render() {
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }
        let i = 0;

        const chartPie = this.props.viewCharts ? <Pie data={this.state.pieData} options={{legend: {position: 'bottom'}}}/> : null
        const tableClass = this.props.viewCharts ? "ten wide column" : "sixteen wide column"
        const chartClass = this.props.viewCharts ? "six wide column" : ""

        return (<div className="ui two columns grid">
            {/*Qui ci va la tabella*/}
            <div className={tableClass}>

                <Table celled>
                    {/*<Table.Header>*/}
                    {/*    <Table.Row>*/}
                    {/*        <Table.HeaderCell>*/}
                    {/*            Utente*/}
                    {/*        </Table.HeaderCell>*/}
                    {/*        <Table.HeaderCell textAlign='center'>*/}
                    {/*            Numero Attività*/}
                    {/*        </Table.HeaderCell>*/}
                    {/*        <Table.HeaderCell textAlign='center'>*/}
                    {/*            Durata Totale (minuti)*/}
                    {/*        </Table.HeaderCell>*/}
                    {/*        <Table.HeaderCell textAlign='center'>*/}
                    {/*            Durata Totale (h:m:s)*/}
                    {/*        </Table.HeaderCell>*/}
                    {/*    </Table.Row>*/}
                    {/*</Table.Header>*/}
                    <Table.Body>
                            <Table.Row style={{fontWeight: 'bold', height: '100px'}}>
                                <Table.Cell>
                                    Utente
                                </Table.Cell>
                                <Table.Cell textAlign='center'>
                                    Numero Attività
                                </Table.Cell>
                                <Table.Cell textAlign='center'>
                                    Durata Totale (minuti)
                                </Table.Cell>
                                <Table.Cell textAlign='center'>
                                    Durata Totale (h:m)
                                </Table.Cell>
                            </Table.Row>
                        {
                            this.state.items.map((item) => {
                                return <Table.Row key={i++}>
                                    <Table.Cell>{item.idUtente.username}</Table.Cell>
                                    <Table.Cell  textAlign='center'>{item.numAttivita}</Table.Cell>
                                    <Table.Cell  textAlign='center'>{item.durataPesata}</Table.Cell>
                                    <Table.Cell  textAlign='center'>{minutesToHuman(item.durataPesata)}</Table.Cell>
                                </Table.Row>
                            })}
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell  textAlign="right">Totali</Table.HeaderCell>
                            <Table.HeaderCell  textAlign='center'><b>{this.state.numAttivitaTotale}</b></Table.HeaderCell>
                            <Table.HeaderCell  textAlign='center'><b>{this.state.durataPesataTotale}</b></Table.HeaderCell>
                            <Table.HeaderCell  textAlign='center'><b>{minutesToHuman(this.state.durataPesataTotale)}</b></Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>

            </div>
            {/*Qui ci va la torta*/}
            <div className={chartClass}>
                {chartPie}
            </div>
            {loader}
        </div>)
    }
}

ReportCommesseGaraLavoratori.PropTypes = {
    commessa: PropTypes.object.isRequired,
    viewCharts: PropTypes.bool.isRequired,
}


ReportCommesseGaraLavoratori.defaultProps = {
    viewCharts: false,
};

export default ReportCommesseGaraLavoratori;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportCommesseGaraLavoratori.js
 **/